import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { resolveLocalized, resolveOptions, type LocalizedText } from '@arna-med/shared';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Re-exported for template-field rendering: resolve a plain string (legacy) or
// a localized { en, ru, kz } object to the current UI language.
export { resolveLocalized, resolveOptions };
export type { LocalizedText };

export function getLocalizedName(
  item: { name: string; nameRu?: string | null; nameKz?: string | null },
  language: string,
): string {
  if (language === 'ru') return item.nameRu || item.name;
  if (language === 'kz') return item.nameKz || item.nameRu || item.name;
  return item.name;
}
